import React, { useState, useEffect } from "react";
import "./Capabilities.css";
import { useMenu } from '../components/context/MenuContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const capabilitiesData = [
  {
    name: "Software Development",
    id: "softwareDevelopment",
    description:
      "Delivering robust, scalable, and secure software solutions tailored to your business needs.",
    image: "/images/software_development.webp",
    details: (
      <>
        <p>
          Software development is at the core of what we do. Our team works closely with clients to understand their unique challenges and deliver solutions that drive their business forward. We use cutting-edge technologies to create robust and scalable software, ensuring that your applications are secure, maintainable, and optimized for performance.
        </p>
        <p>
          Our software development lifecycle follows industry best practices, from planning and design to testing and deployment. We prioritize clean code, rigorous testing, and continuous integration to ensure high-quality results.
        </p>
        {/* <img src="/images/software_development_details.webp" alt="Software Development" /> */}
        <p>
          Key Technologies: React, Node.js, Python, Java, Ruby on Rails, and more.
        </p>
      </>
    ),
  },
  {
    name: "Cloud Services",
    id: "cloudServices",
    description:
      "Optimizing your cloud infrastructure for seamless scalability and reduced costs.",
    image: "/images/cloud_services.jpg",
    details: (
      <>
        <p>
          Our cloud services are designed to optimize your infrastructure for maximum efficiency, scalability, and cost savings. Whether you're looking to migrate to the cloud or improve your existing cloud architecture, our team has the expertise to deliver secure, scalable solutions.
        </p>
        <p>
          We work with major cloud providers such as AWS, Azure, and Google Cloud, ensuring that we select the right tools and services to meet your unique requirements.
        </p>
        {/* <img src="/images/cloud_services_details.jpg" alt="Cloud Services" /> */}
        <p>
          We specialize in cloud-native architectures, containerization, serverless computing, and DevOps practices to ensure that your systems are resilient and scalable.
        </p>
      </>
    ),
  },
  {
    name: "Product Engineering",
    id: "productEngineering",
    description:
      "Innovating and building products from concept to deployment with precision.",
    image: "/images/product-engineering.webp",
    details: (
      <>
        <p>
          Our product engineering services focus on transforming ideas into successful products. From the initial concept to deployment, we help design, develop, and refine your product to meet market demands. We combine technical expertise with user-centered design to deliver products that not only perform well but are also intuitive to use.
        </p>
        <p>
          We work closely with you to iterate on designs, validate assumptions, and ensure that your product meets the highest standards of quality. Our engineers are skilled in both hardware and software development, ensuring end-to-end solutions that drive success.
        </p>
        {/* <img src="/images/product-engineering_details.webp" alt="Product Engineering" /> */}
        <p>
          Key Areas: IoT development, embedded systems, mobile applications, and more.
        </p>
      </>
    ),
  },
  {
    name: "SRE",
    id: "SRE",
    description:
      "Ensuring reliability and performance with modern Site Reliability Engineering practices.",
    image: "/images/sre.jpg",
    details: (
      <>
        <p>
          Site Reliability Engineering (SRE) is about applying software engineering principles to operations. Our SRE practices focus on improving system reliability, automating manual processes, and ensuring that your systems can scale efficiently. We work with teams to design and maintain high-availability systems, monitor performance, and ensure continuous improvement.
        </p>
        <p>
          Our SRE experts focus on proactive measures such as capacity planning, automation, incident management, and post-mortem analysis to reduce downtime and improve system reliability.
        </p>
        {/* <img src="/images/sre_details.jpg" alt="SRE" /> */}
        <p>
          Key Practices: SLIs, SLOs, error budgets, chaos engineering, and more.
        </p>
      </>
    ),
  },
];

const Capabilities = () => {
  const [selectedCapability, setSelectedCapability] = useState(null);

  const { selectedSubItem } = useMenu(); 

  useEffect(() => {
    if (selectedSubItem) {
      const selected = capabilitiesData.find(
        (capability) => capability.id === selectedSubItem
      );
      setSelectedCapability(selected);
    }
  }, [selectedSubItem]);

  const handleCardClick = (capability) => {
    setSelectedCapability(capability); // Set the full capability object on card click
  };

  const handleBackClick = () => {
    setSelectedCapability(null); // Go back to the grid view
  };

  return (
    <div className="capabilities-container">
      <h1 className="capabilities-title">Our Capabilities</h1>
      {selectedCapability ? (
        <div className="capability-details">
          <div className="capability-details-header">
            <h2>{selectedCapability.name}</h2>
            <button onClick={handleBackClick} className="back-button" style={{ display: 'flex', alignItems: 'center' }}>
              <ArrowBackIcon style={{ marginRight: 8 }} /> {/* Icon with margin to space out from text */}
              Back
           </button>
          </div>
          <div className="capability-content">
            <div className="capability-content-wrapper">
              <div className="capability-details-image">
                  <img src={selectedCapability.image} alt={selectedCapability.name} loading="lazy" className="capability-image-left" />
              </div>
              <div className="capability-details-text">
                {selectedCapability.details}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="capabilities-grid">
          {capabilitiesData.map((capability, index) => (
            <div
              key={index}
              className="capability-card"
              onClick={() => handleCardClick(capability)}
            >
              <div
                className="capability-image"
                style={{ backgroundImage: `url(${capability.image})` }}
              ></div>
              <div className="capability-info">
                <h2>{capability.name}</h2>
                <p>{capability.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Capabilities;
